import React, { useEffect, useState } from "react";
import DataTable from "../../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../../Common/DataTableFooter/DataTableFooter";
import { roomCleaningColumns } from "./RoomCleaningTableData";
import api from "../../../../../../api/axios";

const RoomCleaningTable = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);

      const roomRes = await api.get("/pms/rooms");
      const logRes = await api.get("/pms/housekeeping");
      const userRes = await api.get("/users");

      const rooms = roomRes.data ?? [];
      const logs = logRes.data ?? [];
      const users = userRes.data ?? [];

      // Filter rooms ONLY having logs
      const roomIdsHavingLogs = [...new Set(logs.map((log) => log.room_id))];

      const formatted = roomIdsHavingLogs.map((roomId) => {
        const room = rooms.find((r) => r.id === roomId);

        const roomLogs = logs
          .filter((l) => l.room_id === roomId)
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

        const lastLog = roomLogs[0];

        // resolve user
        const assignedUserName =
          users.find((u) => u.id === lastLog.assigned_to_user_id)?.name ?? "-";

        // ⭐ Convert inspected → Completed
        const hkStatus =
          lastLog.status === "inspected" ? "Completed" : lastLog.status;

        return {
          Id: room.id,
          roomNumber: room.room_number,
          roomStatus: room.status,
          hkStatus: hkStatus,
          empName: assignedUserName,
          date: lastLog?.created_at
            ? new Date(
                new Date(lastLog.created_at).getTime() + 5.5 * 60 * 60 * 1000
              ).toLocaleDateString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "-",
        };
      });

      setRows(formatted);
    } catch (err) {
      console.log("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <DataTableHeader />

      {loading ? (
        <div className="text-center py-4">
          <div className="spinner-border text-primary"></div>
        </div>
      ) : (
        <DataTable columns={roomCleaningColumns} data={rows} />
      )}

      {/* <DataTableFooter dataT={rows} /> */}
    </>
  );
};

export default RoomCleaningTable;
